import React, {Component} from "react";
import connected from "./../assets/images/icons/followers.png"

class FeedFollowComponent extends Component{
    render() {
        return(
            <div className="card">
                <div className="feedBox">
                    <div className="feedBox-header">
                        <div className="feedBox-header-profile">
                            <span>UserA is connected to UserB</span>
                        </div>
                    </div>
                    <div className="feedBox-body">
                        <img className="md-img-feed" src={connected} alt=""/>
                    </div>
                </div>
            </div>
        )
    }
}

export default FeedFollowComponent